/**
 * List of Environments
 * DEV  :   Development
 * QAS  :   Qaulity Assurance (UAT)
 * PRD  :   Production
 */
const env = "PRD";
let envconfigs = {};
envconfigs.CHANGIGMC_URL = "https://www.changigmc.com/";
envconfigs.ACTION_GET_GATES_DATA = "getGatesData";
envconfigs.ACTION_ON_GATES_UPDATE = "onGateUpdate";
envconfigs.ACTION_ON_GET_S3_MESSAGE = "getS3Message";
envconfigs.ACTION_ON_GET_S3_MESSAGE_UPDATE = "readMessage";
envconfigs.ACTION_UPDATE_VALIDATE_INSTRUCTION = "updateValidateInstruction";
envconfigs.TIME_CAP = 45; //in minutes
envconfigs.HEARTBEAT_INTERVAL = 15000; //in mili seconds

if (env === "DEV") {
  envconfigs.DEBUG = true;
  envconfigs.USERPOOLID = "ap-southeast-1_sxLHg7Eya";
  envconfigs.CLIENTID = "3co4948276i8pdr1m4vbbst8ca";
  envconfigs.LOGINS =
    "cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_sxLHg7Eya";
  envconfigs.SOCKET_ROOT_URL =
    "wss://1cnt3jajn0.execute-api.ap-southeast-1.amazonaws.com/devPBS?access_token=";
  envconfigs.MEDIA_PATH = "https://uat-ao.changiairport.com/way2go/static/media/";
  envconfigs.USERNAME = "alisha.tham@changiairport.com"; //driver1       atco1
  envconfigs.PASSWORD = "J!33*uMH"; // DRIVER@bcd1  ATCO@bcd1
  envconfigs.GET_SESSION_INFO_API_URL = 'https://cb6hi7uph7.execute-api.ap-southeast-1.amazonaws.com/UAT/sweet-validate';
  envconfigs.GET_SESSION_INFO_API_KEY = 'K0Lu5g1Ck84CmZ9X9Rjc93lfKAeZDalo59y2Y7gz';
  envconfigs.GET_KILL_SWITCH_API_URL = 'https://cb6hi7uph7.execute-api.ap-southeast-1.amazonaws.com/UAT/gets3message';
  envconfigs.GET_KILL_SWITCH_API_KEY = 'K0Lu5g1Ck84CmZ9X9Rjc93lfKAeZDalo59y2Y7gz';
  envconfigs.ENCRYPT_TOKEN_API_URL = 'https://cb6hi7uph7.execute-api.ap-southeast-1.amazonaws.com/UAT/EncryptToken';
  envconfigs.ENCRYPT_TOKEN_API_KEY = 'K0Lu5g1Ck84CmZ9X9Rjc93lfKAeZDalo59y2Y7gz';

} else if (env === "QAS") {
  // envconfigs.DEBUG = false;
  envconfigs.USERPOOLID = "ap-southeast-1_sxLHg7Eya";
  envconfigs.CLIENTID = "3co4948276i8pdr1m4vbbst8ca";
  envconfigs.LOGINS =
    "cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_sxLHg7Eya";
  envconfigs.SOCKET_ROOT_URL =
    "wss://1cnt3jajn0.execute-api.ap-southeast-1.amazonaws.com/devPBS?access_token=";
  envconfigs.MEDIA_PATH = "/way2go/static/media/";
  envconfigs.USERNAME = "";
  envconfigs.PASSWORD = "";
  envconfigs.GET_SESSION_INFO_API_URL = 'https://cb6hi7uph7.execute-api.ap-southeast-1.amazonaws.com/UAT/sweet-validate';
  envconfigs.GET_SESSION_INFO_API_KEY = 'K0Lu5g1Ck84CmZ9X9Rjc93lfKAeZDalo59y2Y7gz';
  envconfigs.GET_KILL_SWITCH_API_URL = 'https://cb6hi7uph7.execute-api.ap-southeast-1.amazonaws.com/UAT/gets3message';
  envconfigs.GET_KILL_SWITCH_API_KEY = 'K0Lu5g1Ck84CmZ9X9Rjc93lfKAeZDalo59y2Y7gz';
  envconfigs.ENCRYPT_TOKEN_API_URL = 'https://cb6hi7uph7.execute-api.ap-southeast-1.amazonaws.com/UAT/EncryptToken';
  envconfigs.ENCRYPT_TOKEN_API_KEY = 'K0Lu5g1Ck84CmZ9X9Rjc93lfKAeZDalo59y2Y7gz';

} else if (env === "PRD") {
  envconfigs.DEBUG = false;
  envconfigs.USERPOOLID = "ap-southeast-1_IMLp8CXbV";
  envconfigs.CLIENTID = "6gruroh3al12i437dju053j81q";
  envconfigs.LOGINS =
    "cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_IMLp8CXbV";
  envconfigs.SOCKET_ROOT_URL =
    "wss://3c5rqx2v24.execute-api.ap-southeast-1.amazonaws.com/prod?access_token=";
  envconfigs.MEDIA_PATH = "/way2go/static/media/";
  envconfigs.USERNAME = "";
  envconfigs.PASSWORD = "";
  envconfigs.GET_SESSION_INFO_API_URL = 'https://bwk20h04ae.execute-api.ap-southeast-1.amazonaws.com/prod/sweet-validate';
  envconfigs.GET_SESSION_INFO_API_KEY = 'AOMo2H8o9jaxDoVRLFqJM7n9zJewV18B8tmBsoew';
  envconfigs.GET_KILL_SWITCH_API_URL = 'https://bwk20h04ae.execute-api.ap-southeast-1.amazonaws.com/prod/gets3message';
  envconfigs.GET_KILL_SWITCH_API_KEY = 'AOMo2H8o9jaxDoVRLFqJM7n9zJewV18B8tmBsoew';
  envconfigs.ENCRYPT_TOKEN_API_URL = 'https://bwk20h04ae.execute-api.ap-southeast-1.amazonaws.com/prod/EncryptToken';
  envconfigs.ENCRYPT_TOKEN_API_KEY = 'AOMo2H8o9jaxDoVRLFqJM7n9zJewV18B8tmBsoew';

}

export default envconfigs;
